import { HttpContext } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { siQuoteUrls } from '../../../environments/environment';
import { GetNotificationsForUserRequest, GetNotificationsForUserResponse, SetNotificationReadStatusRequest, DeleteNotificationForUserRequest } from "../../models/dtos";
import { BaseHttpService } from "./base-http.service";
import { UserProfileService } from "../common/user-profile.service";
import { withSilentBackgroundRequest } from '../../core/errors/http-context-tokens';

@Injectable({
  providedIn: 'root'
})
export class NotificationApiService {

  constructor(private readonly baseHttp: BaseHttpService,
    private readonly userProfileService: UserProfileService
  ) { }

  getNotificationsForUser(requestBody: GetNotificationsForUserRequest): Observable<GetNotificationsForUserResponse> {
    const context: HttpContext = withSilentBackgroundRequest();
    requestBody.userId = this.userProfileService.userInfo?.gid ?? "";
    return this.baseHttp.post<GetNotificationsForUserResponse>(`${siQuoteUrls.notification}/GetNotificationsForUser`, requestBody, { context });
  }

  setNotificationReadStatus(requestBody: SetNotificationReadStatusRequest): Observable<boolean> {
    requestBody.userId = this.userProfileService.userInfo?.gid ?? "";
    return this.baseHttp.post<boolean>(`${siQuoteUrls.notification}/SetNotificationReadStatus`, requestBody);
  }

  deleteNotificationForUser(requestBody: DeleteNotificationForUserRequest): Observable<boolean> {
    requestBody.userId = this.userProfileService.userInfo?.gid ?? "";
    return this.baseHttp.post<boolean>(`${siQuoteUrls.notification}/DeleteNotificationForUser`, requestBody);
  }
}
